import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Grid, Box, IconButton, Tooltip, Backdrop, SpeedDial, SpeedDialAction } from '@mui/material';

// Icons
import TagTwoToneIcon from '@mui/icons-material/TagTwoTone';
import ForumTwoTone from '@mui/icons-material/ForumTwoTone';
import HomeTwoTone from '@mui/icons-material/HomeTwoTone';
import StorefrontTwoTone from '@mui/icons-material/StorefrontTwoTone';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import SpeedTwoTone from '@mui/icons-material/SpeedTwoTone';
import RocketLaunchTwoToneIcon from '@mui/icons-material/RocketLaunchTwoTone'; // New Icon for CTA

// Imports
import MainBanner from './ExperiencesHero';
import Map from './RegionsSection';
import Destinations from '../pages/Destinations';
import Trips from './SignatureJourneys';
import CTa from './CTA';
import Footer from '../Footer';

const socialActions = [
    { icon: <XIcon />, name: 'X', link: 'https://www.x.com' },
    { icon: <InstagramIcon />, name: 'Instagram', link: 'https://www.instagram.com/Maqtoofficial' },
    { icon: <FacebookIcon />, name: 'Facebook', link: 'https://www.facebook.com/profile.php?id=61561945376958&mibextid=ZbWKwL' },
    { icon: <LinkedInIcon />, name: 'LinkedIn', link: 'https://www.linkedin.com' },
    { icon: <GitHubIcon />, name: 'GitHub', link: 'https://github.com/MaqtoOfficial' },
];

const Index = () => {
    const [showScrollUI, setShowScrollUI] = useState(false);
    const [open, setOpen] = useState(false);
    
    const heroRef = useRef(null);
    const aboutRef = useRef(null);
    const brandsRef = useRef(null);
    const animationRef = useRef(null);
    const servicesRef = useRef(null);
    const timeRef = useRef(null);
    const coraidiRef = useRef(null);
    const testimonialsRef = useRef(null);
    const ctaRef = useRef(null); // ★★★ FIXED: Added a new ref for the CTA button
    const footerRef = useRef(null);

    const pageSections = useMemo(() => [
        { id: 'hero', name: 'Welcome', ref: heroRef, icon: <HomeTwoTone /> },
        { id: 'about', name: 'About Us', ref: aboutRef, icon: <SpeedTwoTone  /> },
        { id: 'brands', name: 'Our Partners', ref: brandsRef, icon: <StorefrontTwoTone /> },
        { id: 'animation', name: 'Our softwear lifestyle', ref: animationRef, icon: <StorefrontTwoTone /> },
        { id: 'services', name: 'Our Services', ref: servicesRef, icon: <StorefrontTwoTone /> },
        { id: 'time', name: 'Our Journey', ref: timeRef, icon: <SpeedTwoTone /> },
        { id: 'testimonials', name: 'Testimonials', ref: testimonialsRef, icon: <SpeedTwoTone /> },
        { id: 'coraidi', name: 'Coraidi ERP', ref: coraidiRef, icon: <SpeedTwoTone /> },
        { id: 'cta', name: 'Get Started', ref: ctaRef, icon: <RocketLaunchTwoToneIcon /> }, // ★★★ FIXED: Added CTA to navigation
        { id: 'footer', name: 'Contact Us', ref: footerRef, icon: <ForumTwoTone /> },
    ], []);


   
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleActionClick = (link) => window.open(link, '_blank');
    const goToContact = () => window.location.href = '/contact';

    return (
        <Grid container spacing={0} justifyContent="center" sx={{ width: "100%", margin: 0, padding: 0, overflowX: 'hidden' }}>
            
            <Grid item xs={12} ref={heroRef}>
                <MainBanner />
            </Grid>
            <Grid item xs={12}>
                <Destinations />
            </Grid>
            <Grid item xs={12} ref={ctaRef} sx={{ mb: 5 }}>
                <Trips />
            </Grid>
            <Grid item xs={12}>
                <Footer />
            </Grid>

            

            
            
            {/* ... Floating UI Cluster ... */}
             <Box sx={{ position: 'fixed', bottom: { xs: 104, sm: 96 }, right: 16, zIndex: 1050, transform: showScrollUI ? 'scale(1)' : 'scale(0)', transition: 'transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)', transformOrigin: 'bottom right', }}>
                <Tooltip title="Contact Us" placement="left">
                    <IconButton onClick={goToContact} sx={{ backgroundColor: '#ffc107', color: 'black', width: 56, height: 56, boxShadow: '0px 6px 16px rgba(0,0,0,0.3)', '&:hover': { backgroundColor: '#ffca28', transform: 'rotate(15deg) scale(1.1)', }, transition: 'background-color 0.2s, transform 0.2s ease-out' }} >
                        <ForumTwoTone />
                    </IconButton>
                </Tooltip>
            </Box>
        </Grid>
    );
};

export default Index;